module.exports = __webpack_public_path__ + "img/weight.jpg.1715687f.webp";